const _ = require('underscore');
const AppView = require('../appView');

require('jquery.scrollto')
require('./../../utils.js')

require('imagesloaded')
window.bootstrap = require('bootstrap')
require('bootstrap-select')

const pinSVG = require('../../../../svg/pin.svg');

var pauseRAF = false,
	rafControllerInt = 0

// const innerHeight = require('ios-inner-height');

// require('bootstrap-datepicker');


require('slick-carousel')
// require('slick-lightbox')
// import $ from 'jquery';
var rafId = 0;
// let { is_touch_device } = require('../../utils.js');

// const Rellax = require('rellax')

// const Timeline = require('vis-timeline/standalone')
// import { Timeline } from "vis-timeline/standalone"





const DefaultView = Backbone.View.extend({
	el: '#content',

	st: 0,

	map: null,

	maptiler: null,

	markers: [],

	mapView: 'map-default',

	mapBounds: {
			'map-a' : new google.maps.LatLngBounds(
		    			new google.maps.LatLng(51.966441, -0.878550),
		    			new google.maps.LatLng(52.093515, -0.659372)
					),
			'map-b' : new google.maps.LatLngBounds(
		    			new google.maps.LatLng(51.966441, -0.878550),
		    			new google.maps.LatLng(52.093515, -0.659372)
					),
			'map-c' : new google.maps.LatLngBounds(
		    			new google.maps.LatLng(51.966441, -0.878550),
		    			new google.maps.LatLng(52.093515, -0.659372)
					),
			'map-oct' : new google.maps.LatLngBounds(
		    			new google.maps.LatLng(51.716659, -1.268772),
    					new google.maps.LatLng(52.236174, -0.546480)
					),
			// 'map-heritage': new google.maps.LatLngBounds(
			// 				    new google.maps.LatLng(51.962386, -0.883647),
			// 				    new google.maps.LatLng(52.099084, -0.598560)),
			// 'map-designation': new google.maps.LatLngBounds(
			// 				    new google.maps.LatLng(51.962386, -0.883647),
			// 				    new google.maps.LatLng(52.099084, -0.598560)),
			// 'map-interim-report': new google.maps.LatLngBounds(
			// 				    new google.maps.LatLng(51.962386, -0.883647),
			// 				    new google.maps.LatLng(52.099084, -0.598560)),
	},

	videoIds: [],

	filters: [],

	mapInitialised: 0,

	initialize() {
		let _this = this;
	
        $(window).smartresize(_.bind(this._onWindowResize, this));     

        // $('body').on('onYouTubeIframeAPIReady', _.bind(this._onYouTubeIframeAPIReady, this));

		// $('body').on('initMap', _.bind(this._initMap, this));
	
		// $(window).on('scroll', _.bind(this._onWindowScroll, this));				
		_this.heroSliderOptions = {
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			fade: false,
			dots: false,
			arrows: true,
			// autoplay: false,
			// speed: 1200,
			// autoplaySpeed: 5000,
			// pauseOnHover: false,
			rows: 0,
			// slide: 'article'
			prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><span class="icon-b2left"></span></button>',
			nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><span class="icon-b2right"></span></button>',

			responsive: [
			    
			    {
			      breakpoint: 768,
			      settings: {
			        slidesToShow: 1,
			        slidesToScroll: 1,
			        centerMode: false,
			        autoplay: true,
					speed: 1200,
					autoplaySpeed: 5000,
					pauseOnHover: true,
					adaptiveHeight: true,
			      }
			    },
			    // {
			    //   breakpoint: 480,
			    //   settings: {
			    //     slidesToShow: 1,
			    //     slidesToScroll: 1
			    //   }
			    // }
			    // You can unslick at a given breakpoint now by adding:
			    // settings: "unslick"
			    // instead of a settings object
  			]
		}

	},	

	// _initMap() {
	// 	if ( $('#visit-map').length ) { 
	// 		const lat = 51.512971669210266,
	// 			lng = 0.006115385443783041,
	// 			zoom = 15,
	// 			iconBase = AC.tmpldir,
	// 			customIcon = {
	// 				url: iconBase + '/assets/source/img/icon-pin@2x.png',
 //    				size: new google.maps.Size(30, 37),
 //    				scaledSize: new google.maps.Size(30, 37),
	// 				origin: new google.maps.Point(1,3)
	// 			}

	// 		this.map = new google.maps.Map( $('#visit-map')[0], {
	// 				center: {
	// 					lat: lat,
	// 					lng: lng 
	// 				},
	// 				minZoom: 5, 
	// 				maxZoom: 16,
	// 				mapTypeId: 'roadmap',
	// 				mapTypeControlOptions: {
	// 					mapTypeIds: ['roadmap']
	// 				},
	// 				mapTypeControl: true,
	// 				streetViewControl: false,
	// 				backgroundColor: '#FFFFFF',
	// 				scrollwheel: false,
	// 				fullscreenControl: false,
				
	// 				zoom: zoom
	// 		})

	// 		const marker = new google.maps.Marker({
	// 			position: new google.maps.LatLng(lat, lng),
	// 			icon: customIcon,
	// 			map: this.map
	// 		})
	// 	}

	// },

	

	stopRaf(rafId) {
		cancelAnimationFrame(rafId);
	},

	events: {

		'click .timeline-toggle' : '_timelineToggleHandler',
		
		// 'mouseenter .timeline' : '_timelineMouseEnterHandler',
		// 'mousemove .timeline' : '_timelineMouseEnterHandler',
		// 'mouseleave .timeline' : '_timelineMouseOutHandler',

		'change .listing-filters #theme'			: '_themeChangeHandler', 


		'change #map-view'		: '_mapChangeHandler',

		'change .map-control #theme' : '_mapThemeChangeHandler',


		'click .pagination .load-more' : '_loadMoreClickHandler',

		'click .close-map-popup' 			: '_closeMapPopup',
	},


	_closeMapPopup(e) {
		e.preventDefault()

		$('#map-wrapper').removeClass('ui-map-popup-on')

	},

	_loadMoreClickHandler(e) {
		e.preventDefault()
		const _this = this

		let $a = $(e.currentTarget),
			container = $a.attr('data-container'),
			next = $a.attr('data-next-page'),
			model = $(`${container}`).attr('data-model')

		_this.paginationLoadMore(container, model, next)

		return false
	},

	_mapChangeHandler(e) {

		e.preventDefault()

		let _this = this,
			$s = $(e.currentTarget),
			v = $('option:selected', e.currentTarget).val()


		// console.log(v)


		if ( v && v != 'map-default') {
			_this.map.overlayMapTypes.insertAt(1, _this.maptiler);
		} else {
			_this.map.overlayMapTypes.clear();
		}


		_this.mapView = v

		_this.map.setZoom(12)

		$('.map-credits').hide()

	    $(`.map-credits[data-map-view="${_this.mapView}"]`).show()
	    
	    console.log(`.map-credits[data-map-view="${_this.mapView}"]`)

	},

	_mapThemeChangeHandler(e) {
		e.preventDefault()

		var 
			_this = this,
			$s = $(e.currentTarget),
			v  = $('option:selected', e.currentTarget).val()

		_this.filters.push({
			'theme' : v
		})

		_this.reloadMapMarkers( )

		return false

	},

	reloadMapMarkers() {

		let _this = this


		if ( _this.markers.length ) _this.deleteMarkers()

		$.ajax({
    		url: AC.ajaxurl,
    		type: 'get',
    		dataType: 'json',
    		data: {
    			action: 'getMapMarkers',
    			filters: _this.filters,
    		},
    		success: function(json) {

    			if ( json.markers.length ) {

    				json.markers.forEach( (m, i) => {
    					// console.log(m)
						_this.addMarker(m.map_coordinates.lat, m.map_coordinates.lng, m.post)
    				})
				}
	    			
    		}

    	})
	},


	_themeChangeHandler(e) {
		e.preventDefault()

		var 
			_this = this,
			$s = $(e.currentTarget),
			v  = $('option:selected', e.currentTarget).val()

		_this.filters.push({
			'theme' : v
		})

		
		let section = 'articles'
		if ( $s.attr('data-section') && $s.attr('data-section').length ) {
			section = $s.attr('data-section')
		}
		// console.log($s.attr('data-section'))	
		// alert(section)

		_this.reloadListing( section )

		return false

	},

	paginationLoadMore( container, section, next) {

		let _this = this

		$('body').addClass('ui-loading-listing')


		$.ajax({
			url: AC.ajaxurl,
			type: 'get',
			dataType: 'html',
			data: {
				action: 'getListing',
				section: section,
				filters: _this.filters,
				page: next
			},
			success: function( result  ) {
				
				$(`#${section}-view .listing .row`).append( $(result).find(`#${section}-view .listing .row`).html() )
				$('body').removeClass('ui-loading-listing')

				if ( $(result).find('.pagination').length ) {
					$(`#${section}-view .pagination`).html( $(result).find('.pagination').html() )
				} else {
					$(`#${section}-view .pagination`).remove()
				}

				_this._onWindowResize()
				$(window).trigger('resize')

				_this.timelineScroll()

			}

		})

		return false

	},


	reloadListing( section ) {

		let _this = this

		$('body').addClass('ui-loading-listing')

		$.ajax({
			url: AC.ajaxurl,
			type: 'get',
			dataType: 'html',
			data: {
				action: 'getListing',
				section: section,
				filters: _this.filters,
			},
			success: function( result  ) {
				
				$(`#${section}-view`).html( $(result).find(`#${section}-view`).html() )
				$('body').removeClass('ui-loading-listing')

				_this._onWindowResize()
				$(window).trigger('resize')

				_this.timelineScroll()

			}

		})

		return false

	},

	_timelineToggleHandler(e) {
		e.preventDefault()

		let 
			_this = this,
			$a = $(e.currentTarget),
			on_c = $a.attr('data-caption-on'),
			off_c = $a.attr('data-caption-off')

		$('body').toggleClass('ui-timeline-view-on')
	
		$a.text( $('body').hasClass('ui-timeline-view-on') ? on_c : off_c )

		if ( $('body').hasClass('ui-timeline-view-on') ) {
			!Site.debug || console.log('disableScroll')
			// _this.disableScroll()
		} else {
			// _this.enableScroll()
		}

		_this._onWindowResize()
		$(window).trigger('resize')

		return false

	},

	forceEnableScroll: false,

	_timelineMouseEnterHandler(e) {
		let _this = this
		!Site.debug || console.log('timeline: mouse enter');
		if ( ! _this.forceEnableScroll )
			_this.disableScroll()
		return false
	},

	_timelineMouseOutHandler(e) {
		let _this = this
		!Site.debug || console.log('timeline: mouse leave');
		_this.enableScroll()	
		return false
	},
	
	

	components() {

		const _this = this;

		$(window).trigger('resize')
		
		app_view.components()

		$('.hero').imagesLoaded()
			.done(() => {
				$('.hero').addClass('hero-loaded')				
			})



		// var rellax = new Rellax('.featured-image-bg', {
		// 	// wrapper: '.heading-section'
		// })

		let heroSliderHomeOpts = {
			appendArrows: $('.hero-text')[0]
		}

		$('.hero-images').slick({ ..._this.heroSliderOptions, ...heroSliderHomeOpts })

		$('.hero-slider').slick(_this.heroSliderOptions)

		let psOptions = {
			appendDots: $('.project-slider--nav-numbers'),
			appendArrows: $('.project-slider--nav-dir'),
			dots: true,
		}

		$('.project-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
			
			  !Site.debug || console.log(currentSlide);
			}).slick({ ..._this.heroSliderOptions, ...psOptions})


		$('.news-filters-dropdown').selectpicker({

		})
		
		let galleryOptions = {

		}

		$('.gallery').slick({ ..._this.heroSliderOptions, ...galleryOptions})

		// let carouselOptions = {

		// }

		$('.mk-carousel').slick({ ..._this.heroSliderOptions/*, ...carouselOptions*/})

		$('.mk-carousel').on('beforeChange', function (){
			$('.mk-carousel .active iframe').each( (index, el) => {
				// console.log( el.contentWindow )
				if ( $(el).attr('src').match('vimeo') ) {
					el.contentWindow.postMessage('{"method":"pause"}', '*');
				} else {
					el.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*')	
				}
				$(el).parents('.video-container-wrap').removeClass('active')
			})
		})


		// Initialize custom cursor
	    // const cursor = new Cursor(document.querySelector('.cursor'));

	    // // Mouse effects on all links and others
	    // [...document.querySelectorAll('a, button')].forEach(link => {
	    //     link.addEventListener('mouseenter', () => cursor.enter());
	    //     link.addEventListener('mouseleave', () => cursor.leave());
	    // });
	    
	    var w = $(window).width()
	    
	    if ( w <= 560 ) {

	    	$('.mobile-items-slider').each(function(){
	    		let $slider = $(this)

	    		$slider.slick({
							infinite: true,
							slidesToShow: 1,
							slidesToScroll: 1,
							fade: false,
							dots: false,
							arrows: true,
							// autoplay: false,
							// speed: 1200,
							// autoplaySpeed: 5000,
							// pauseOnHover: false,
							rows: 0,
							// slide: 'article'
							prevArrow: '<button class="slick-prev visually-hidden slick-arrow" aria-label="Previous" type="button" style=""><span class="icon-b2left"></span></button>',
							nextArrow: '<button class="slick-next visually-hidden slick-arrow" aria-label="Next" type="button" style=""><span class="icon-b2right"></span></button>',

	    				})

	    	})
	    }

	
	},

	render( request ) {
		let _this = this,
			$tmp = $('<div/>'),
			url = Backbone.history.fragment;

		// $('#footer').removeClass('active');
		!Site.debug || console.log('render: ' + Site.routesHit)
		if ( Site.routesHit > 1 )
		{
			$('#content').css({opacity:0});
			$tmp.load( Site.baseURL + url + " #content", function( html ) {
            	
            	setTimeout(function(){
                    app_view.updateTitle(html);
	                $('#content').html($tmp.find('#content').html());
	                $('#content').attr('class', $tmp.find('#content').attr('class'));
	                $tmp.html('');
	                
	                _this.$el.triggerHandler('content:loaded');
	                _this.components();
	                _this.renderPage(request);

	                $(window).trigger('resize');
	                // scroll top
	    //             if (window.storedST ) {

	    //             } else {
					// 	$('body').scrollTo( 0, {duration: 0});	
					// 	$('#content').scrollTo( 0, {duration: 0});	
					// }

					setTimeout( function(){
						$('body').trigger('page:loaded');
					}, 500);
					
				}, 300);
				
            });		
		} else {
			$('body').trigger('page:loaded');
			_this.$el.triggerHandler('content:loaded');
            _this.renderPage(request);
			_this.components();
			// if (window.storedST) {

   //          } else {
			// 	$('body').scrollTo( 0, {duration: 0});	
			// 	$('#content').scrollTo( 0, {duration: 0});	
			// }
		}
	}, 

	renderPage(request) {
		let
			header_timeout, 
			footer_timeout, 
			didScrollInterval, 
			_this = this;


		
		
        let w = $(window).width(),
            h = $(window).height();

        // alert( w + ', ' + h)
        // AOS.init();

        _this.$el.removeAttr('style')

        if ( _this.$el.hasClass('content-explore') ) {
        	_this.renderExploreMap()
        }


        if ( _this.$el.hasClass('content-news') ) {
        	if ( $('#articles-timeline').length ) {


        		_this.timelineScroll()

        	}
        }

        $('.hero-image').each((i, el) => {
        	$(el).imagesLoaded().done(() => {
        		$(el).addClass('loaded')
        	})
        })

	},


	timelineScroll() {

		let _this = this

		// left: 37, up: 38, right: 39, down: 40,
		// spacebar: 32, pageup: 33, pagedown: 34, end: 35, home: 36
		var keys = {37: 1, 38: 1, 39: 1, 40: 1};

		window.preventDefault = (e) => {
		  e.preventDefault();
		}

		window.preventDefaultForScrollKeys = (e) => {
		    if (keys[e.keyCode]) {
		        preventDefault(e);
		        return false;
		    }
		}

		// modern Chrome requires { passive: false } when adding event
		window.supportsPassive = false;
		try {
		  window.addEventListener("test", null, Object.defineProperty({}, 'passive', {
		    get: function () { supportsPassive = true; } 
		  }));
		} catch(e) {}

		window.wheelOpt = supportsPassive ? { passive: false } : false;
		window.wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';


		

		// import {preloadImages, preloadFonts} from '../utils';

		// Preload images
		const preloadImages = (selector = 'img') => {
		    return new Promise((resolve) => {
		        imagesLoaded(document.querySelectorAll(selector), {background: true}, resolve)
		    });
		}

			

		$(window).trigger('resize')
		_this._onWindowResize()

		Promise.all([preloadImages('.timeline__item-inner')]).then(() => {

			_this._onWindowResize()

			// Initialize Locomotive Scroll (horizontal direction)
			const lscroll = new LocomotiveScroll({
			    el: document.querySelector('[data-scroll-container]'),
			    smooth: true,
			    direction: 'horizontal',
			    gestureDirection: 'horizontal',
			    // initPosition: {
			    // 	x: 0, y: 1000
			    // },
			    resetNativeScroll: false,
			    // reloadOnContextChange: true
			})

			lscroll.on('scroll', (args) => {
			    // Get all current elements : args.currentElements
			    // console.log(args)
			    // console.log(args.delta, args.scroll.x, args.limit.x)

			    if (  args.delta.x < 1 && args.scroll.x < 2 || args.delta.x > 50 && args.scroll.x >= args.limit.x - 2 ) {

			    	// console.log('xxx')

			    	_this.enableScroll()
			    	_this.forceEnableScroll = true

			    	_this.fesT = setTimeout(function(){
						_this.forceEnableScroll = false
			    	}, 500)

			    	// return false
			    }
			})
		

			// // Preload images and fonts
			// Promise.all([preloadImages('.timeline__item-inner')]).then(() => {
		    // Remove loader (loading class)
		    document.body.classList.remove('loading');

		    
		});
	},


	// call this to Disable
	disableScroll() {
		console.log('disableScroll2')
		let _this = this
		if ( _this.$el.hasClass('scroll-paused') ) return false;
		window.addEventListener('DOMMouseScroll', preventDefault, false); // older FF
		window.addEventListener(wheelEvent, preventDefault, wheelOpt); // modern desktop
		window.addEventListener('touchmove', preventDefault, wheelOpt); // mobile
		window.addEventListener('keydown', preventDefaultForScrollKeys, false);
		_this.$el.addClass('scroll-paused')
	},

	// call this to Enable
	enableScroll() {
		let _this = this
		if (! _this.$el.hasClass('scroll-paused') ) return false;
		window.removeEventListener('DOMMouseScroll', preventDefault, false);
		window.removeEventListener(wheelEvent, preventDefault, wheelOpt); 
		window.removeEventListener('touchmove', preventDefault, wheelOpt);
		window.removeEventListener('keydown', preventDefaultForScrollKeys, false);
		_this.$el.removeClass('scroll-paused')
	},


	renderExploreMap() {

		const _this = this
		
		const 
			
			mapMinZoom = 8,
			mapMaxZoom = 15

			// mapBounds = new google.maps.LatLngBounds(
   //  			new google.maps.LatLng(51.966441, -0.878550),
   //  			new google.maps.LatLng(52.093515, -0.659372)
			// ),
			
		_this.maptiler = new google.maps.ImageMapType({
    										getTileUrl: function(coord, zoom) { 
														        let proj = _this.map.getProjection(),
														        	z2 = Math.pow(2, zoom),
														        	tileXSize = 256 / z2,
														        	tileYSize = 256 / z2,
														        	tileBounds = new google.maps.LatLngBounds(
														            	proj.fromPointToLatLng(new google.maps.Point(coord.x * tileXSize, (coord.y + 1) * tileYSize)),
														            	proj.fromPointToLatLng(new google.maps.Point((coord.x + 1) * tileXSize, coord.y * tileYSize))
														        	),
														        	x = coord.x >= 0 ? coord.x : z2 + coord.x,
														        	y = coord.y;
														        
														        console.log('map view:::', _this.mapView)
														        
														        if (_this.mapBounds[_this.mapView].intersects(tileBounds) && (mapMinZoom <= zoom) && (zoom <= mapMaxZoom))														            
														            return `/wp-content/uploads/map-tiles/${_this.mapView}/${zoom}/${x}/${y}.jpg`;
														        else
														            return '/wp-content/uploads/map-tiles/blank.png';
														    },
										    tileSize: new google.maps.Size(256, 256),
										    isPng: false,
										    name: "Explore - Map A",
										    alt: "Explore - Map A",
										    // opacity: 1.0
										})

	    var opts = {
	        tilt: 0,
	        streetViewControl: false,
	        // center: new google.maps.LatLng(52.029978, -0.768961),
	        center: new google.maps.LatLng(52.03042037653011, -0.7837984225995582),
	        zoom: 11,
	        minZoom: 8,
	        maxZoom: 15,
	        mapId: '71520a14bf18b008',
	        fullscreenControl: false,
	        mapTypeControl: false,
	        scrollwheel: false,
	    };
	    _this.map = new google.maps.Map(document.getElementById( 'explore-map' ), opts);
	    _this.map.setMapTypeId('roadmap');
	    


	    
	    


    	$.ajax({
    		url: AC.ajaxurl,
    		type: 'get',
    		dataType: 'json',
    		data: {
    			action: 'getMapMarkers',
    		},
    		success: function(json) {

    			if ( json.markers.length ) {

    				json.markers.forEach( (m, i) => {
    					// console.log(m)
						_this.addMarker(m.map_coordinates.lat, m.map_coordinates.lng, m.post)
    				})
				}
	    			
    		}

    	})

	    
		

	},

	deleteMarkers() {
	  	for (let i = 0; i < this.markers.length; i++) {
	    	this.markers[i].setMap(null);
	  	}
	  	this.markers = [];
	},

	addMarker(lat, lng, p) {

		// console.log(lat, lng, p)
		let _this = this,
			pinSVG_path = 'M34.2,109.2c-4.9-9.5-9.3-18.1-13.7-26.6c-5.6-11-11.3-21.9-16.7-32.9C-6,29.9,4.2,6.6,25.5,1.2c25.7-6.6,42.8,14.3,42.7,30.7c-0.1,6.8-0.8,13.2-4,19.3C55,68.9,46,86.7,36.8,104.4C36.2,105.7,35.4,107,34.2,109.2z M34.6,12.6C22,12.5,12.5,22,12.5,34.6c0.2,11.9,9.8,21.4,21.7,21.5c11.9-0.2,21.5-9.6,22-21.5c0.2-12-9.4-21.9-21.4-22C34.7,12.6,34.7,12.6,34.6,12.6L34.6,12.6z'


		function pinSymbol(color) {
    		return {
        		path: pinSVG_path,
        		fillColor: color,
        		fillOpacity: 1,
        	
        		strokeWeight: 0,
        		scale: .4
    		}
    	}

		const marker = new google.maps.Marker({
				position: { lat: lat, lng: lng },
				map: _this.map,
				icon: pinSymbol('#13852a'),
				title: p.post_title,
			})

		this.markers.push (  marker )

		


		const contentString =
		    `<div class="map-infobox">
		    	<a href="${p.link}">
		    	<div class="image-container">
		    		<img src="${p.thumbnail}">
		    	</div>
		    	<div class="map-infobox-head">
		    		${p.title}
	    		</div>
	    		<!-- <div class="map-infobox-excerpt">${p.excerpt}</div> -->
	    		<div class="map-infobox-buttons">
	    			<button class="btn">Find out more</button>
    			</div></a>
		    </div>`
		    
	  	const infowindow = new google.maps.InfoWindow({
		    	content: contentString,
	  	});

		  
		  
	  	marker.addListener('click', () => {
			if ( _this.OpenInfoWindow ) {
				_this.OpenInfoWindow.close();
			}



			!Site.debug || console.log(marker.position, marker.position.lat())
			// _this.map.setCenter( new google.maps.LatLng(marker.getPosition().lat() + .2, marker.getPosition().lng() - .01) )

			// _this.map.setCenter( new google.maps.LatLng(marker.getPosition().lat(), marker.getPosition().lng()) )
			_this.map.panTo( new google.maps.LatLng(marker.getPosition().lat(), marker.getPosition().lng()) )
			

			


			if (! $('#map-wrapper').hasClass('ui-map-popup-on') ) {
				$('#map-marker-details-inner').html(contentString)	
				$('#map-wrapper').addClass('ui-map-popup-on')
			} else {
				$('#map-wrapper').removeClass('ui-map-popup-on')
				setTimeout(function(){
					$('#map-marker-details-inner').html(contentString)	
					$('#map-wrapper').addClass('ui-map-popup-on')	
				}, 500)
				
			}

			setTimeout(function(){
				hideOnClickOutside($('.map-marker-details-wrapper')[0], () => {
					$('#map-wrapper').removeClass('ui-map-popup-on')

					if ( _this.markers.length ) {

						_this.markers.forEach( (m, i) => {
							m.setIcon( pinSymbol('#13852a') )
						})
					}

				})

			}, 500)

			// infowindow.open({
			// 	anchor: marker,
			// 	map: _this.map,
			// 	shouldFocus: false,
			// });

			// _this.OpenInfoWindow = infowindow
			if ( _this.markers.length ) {

				_this.markers.forEach( (m, i) => {
					m.setIcon( pinSymbol('#13852a') )
				})
			}
			marker.setIcon(pinSymbol('#202020'));
	  	});

	},

	_onWindowScroll() {
		let _this = this
		this.st = $(window).scrollTop()
	},
	

	_onWindowResize(e) {
		const w = $(window).width(),
			h = window.innerHeight ? window.innerHeight : $(window).height(),
			_this = this

		_this.w = w
		_this.h = h
		
		!Site.debug || console.log('resize');

		// if ( is_touch_device() ) {


		// }

		var tw = 0
		$('.timeline .timeline__item').each(function(){
			tw += $(this).width()
		})
		// console.log(tw)
		$('.timeline').css({'min-width': tw + 'px'})


		// $('.gallery').each(function(){
		// 	var g = this,
		// 		$g = $(this),
		// 		initial_w = $g.width()



		// 	if ( w > 1024 ) {
		// 		$g.width( initial_w + )
		// 	}
		// })
		
	}


});

module.exports = DefaultView;